import React from 'react';
import { MdAndroid } from 'react-icons/md';
import { BsApple } from 'react-icons/bs';
import { RiSafariFill } from 'react-icons/ri';

function Platforms() {
  return (
    <div className='flex flex-col space-y-3'>
      <p>Supported Platforms</p>
      <div className='flex flex-row justify-center space-x-5'>
        <BsApple className='text-2xl hover:scale-110 hover:cursor-pointer transition translate duration-500' />
        <MdAndroid className='text-2xl hover:scale-110 hover:cursor-pointer transition translate duration-500' />
        <RiSafariFill className='text-2xl hover:scale-110 hover:cursor-pointer transition translate duration-500' />
      </div>
    </div>
  );
}

export default Platforms;
